"use client";

import { Slider } from "@/components/ui/slider";
import { useTranslations } from "next-intl";
import { Dispatch, SetStateAction } from "react";
import TitleH5 from "../fonts/TitleH5";

export interface CountUnitsProps {
  floors: number[];
  setFloors: Dispatch<SetStateAction<number[]>>;
  squareMeter: number[];
  setSquareMeter: Dispatch<SetStateAction<number[]>>;
  livingUnits: number[];
  setLivingUnits: Dispatch<SetStateAction<number[]>>;
  propertyType: "singleFamilyHouse" | "multiFamilyHouse";
}

const CountUnits = ({ ...props }: CountUnitsProps) => {
  const t = useTranslations("measurementService.priceCalculation");
  const isMultiFamily = props.propertyType === "multiFamilyHouse";

  return (
    <div className="m-auto flex max-w-2xl flex-col gap-5">
      <div className="flex flex-col gap-3">
        <div className="flex items-center justify-between gap-3">
          <TitleH5 title={t("floors")} />
          <span className="text-primary text-sm font-semibold tabular-nums">
            {props.floors[0]}
          </span>
        </div>
        <div className="mt-2 flex items-center gap-3">
          <span className="text-primary">
            1<span className="text-transparent">m²</span>
          </span>
          <Slider
            className="w-full max-w-lg"
            defaultValue={[1]}
            min={1}
            max={10}
            step={1}
            value={props.floors}
            onValueChange={props.setFloors}
          />
          <span className="text-primary">
            10
            <span className="text-transparent">m²</span>
          </span>
        </div>
      </div>
      <div className="flex flex-col gap-3">
        <div className="flex items-center justify-between gap-3">
          <TitleH5 title={t("qm")} />
          <span className="text-primary text-sm font-semibold tabular-nums">
            {props.squareMeter[0]}m²
          </span>
        </div>
        <div className="mt-2 flex items-center gap-3">
          <span className="text-primary">15m²</span>
          <Slider
            className="w-full max-w-lg"
            defaultValue={[15]}
            min={15}
            max={1000}
            step={1}
            value={props.squareMeter}
            onValueChange={props.setSquareMeter}
          />
          <span className="text-primary">1000m²</span>
        </div>
      </div>
      {isMultiFamily && (
        <div className="flex flex-col gap-3">
          <div className="flex items-center justify-between gap-3">
            <TitleH5 title={t("units")} />
            <span className="text-primary text-sm font-semibold tabular-nums">
              {props.livingUnits[0]}
            </span>
          </div>
          <div className="mt-2 flex items-center gap-3">
            <span className="text-primary">
              1<span className="text-transparent">m²</span>
            </span>
            <Slider
              className="w-full max-w-lg"
              defaultValue={[1]}
              min={1}
              max={25}
              step={1}
              value={props.livingUnits}
              onValueChange={props.setLivingUnits}
            />
            <span className="text-primary">
              25
              <span className="text-transparent">m²</span>
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default CountUnits;
